import React from "react";
import { Box, Icon, Link, Text } from "~/components-shared";
import { CollapsableTypeEnum, TopicFootprintTypeEnum } from "~/types/enums";
import Collapsable from "~/components/Collapsable";
import FootprintActions from "~/components/FootprintActions";
import Markdown from "~/components/Markdown";
import moment from "moment";
import styled from "styled-components";
const StyledBox = styled(Box)`
  padding-left: 1em;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 3px;
    background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.primary.main;
}};
    width: 3px;
    height: 100%;
  }
`;
const TopicFootprintContentMonday = _ref2 => {
  let {
    footprint
  } = _ref2;
  const {
    actions,
    type,
    data
  } = footprint;
  if ([TopicFootprintTypeEnum.TASK].includes(type)) {
    const {
      itemType,
      itemName,
      itemUrl,
      itemUpdates,
      itemColumns,
      itemIsPrivate,
      itemIsShared,
      boardName,
      boardUrl,
      workspaceName,
      parentItemName
    } = data;
    const columns = itemColumns.filter(column => column.text);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Monday", " ", /*#__PURE__*/React.createElement(Link, {
      href: itemUrl,
      underline: true
    }, itemType ? itemType.toLowerCase() : "item"), !!boardName && /*#__PURE__*/React.createElement(React.Fragment, null, " ", "on", " ", /*#__PURE__*/React.createElement(Link, {
      href: boardUrl,
      underline: true
    }, itemIsPrivate ? "🔒 " : "", itemIsShared ? "🔁 " : "", boardName), " ", "board")), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        mt: 1,
        mb: 2
      }
    }, !!parentItemName && /*#__PURE__*/React.createElement(React.Fragment, null, parentItemName, " ", /*#__PURE__*/React.createElement(Icon, {
      src: "arrow",
      s: {
        mr: 2
      }
    })), itemName), !!itemUpdates.length && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 200,
      type: CollapsableTypeEnum.LINE,
      s: {
        my: 1
      }
    }, /*#__PURE__*/React.createElement(StyledBox, {
      gap: 3,
      direction: "column"
    }, itemUpdates.map(update => {
      return /*#__PURE__*/React.createElement(Box, {
        gap: 3,
        direction: "column"
      }, /*#__PURE__*/React.createElement(Box, {
        direction: "column"
      }, /*#__PURE__*/React.createElement(Text, {
        display: "block",
        color: "text",
        s: {
          mb: 1
        }
      }, /*#__PURE__*/React.createElement(Text, {
        weight: "semiBold"
      }, update.creator.name), " ", /*#__PURE__*/React.createElement(Text, {
        color: "textSecondary"
      }, "on ", moment(update.createdAt).format("ddd, MMM D hh:mma"), ":")), /*#__PURE__*/React.createElement(Markdown, {
        text: update.body,
        fontSize: 4
      })), !!update.replies?.length && /*#__PURE__*/React.createElement(Box, {
        gap: 3,
        direction: "column"
      }, update.replies?.map(reply => /*#__PURE__*/React.createElement(Box, {
        direction: "column",
        s: {
          pl: 3
        }
      }, /*#__PURE__*/React.createElement(Text, {
        display: "block",
        weight: "semiBold",
        color: "text",
        s: {
          mb: 1
        }
      }, reply.creator.name, " ", /*#__PURE__*/React.createElement(Text, {
        color: "textSecondary"
      }, "on ", moment(reply.createdAt).format("ddd, MMM D hh:mma"), ":")), /*#__PURE__*/React.createElement(Markdown, {
        text: reply.body,
        fontSize: 4
      })))));
    }))), !!columns.length && /*#__PURE__*/React.createElement(Box, {
      gap: 0.5
    }, columns.map(column => /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      s: {
        mr: 5
      }
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold"
    }, column.title), ": ", column.text)), workspaceName && /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      s: {
        mr: 5
      }
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold"
    }, "Workspace"), ": ", workspaceName)));
  }
  return /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, "Unknown event");
};
export default TopicFootprintContentMonday;